import React from 'react'
import style from './marketing.module.scss'
import { Header } from '../../components/navigation/header/Header'
import { MarketingForm } from '../../components/marketing/form/MarketingForm'
import {
	MarketingFormSectionDatas,
	MarketingSection
} from '../../components/marketing/section/MarketingSection'
import { VegaCard } from '../../components/vega/card/Card'
import cx from 'classnames'

export const Marketing = () => {
	return (
		<div className={style.marketing}>
			<Header />
			<div className={style.content}>
				<VegaCard
					hasShadow={false}
					className={cx(style.card, 'animate__animated', 'animate__fadeInUp')}
				>
					<MarketingSection {...MarketingFormSectionDatas} />
					<MarketingForm />
				</VegaCard>
			</div>
		</div>
	)
}
